module.exports = __webpack_public_path__ + "img/panelView_defaultBg_3_3.51e9280e.png";